const template = require('./admin_header.html.slim')
declare var angular

export class AdminHeader {
  static $inject = ['User', 'Client']

  public user
  public profile

  private userResource
  private clientResource
  private _userId: number

  constructor(private User, private Client) {
    this.userResource = User
    this.clientResource = Client
  }

  get userId() { return this._userId }
  set userId(value) {
    this._userId = value
    if (value !== undefined) {
      this.userResource.get({ id: value }, (user) => { this.user = user })
      this.clientResource.get({ id: value }, (profile) => { this.profile = profile })
    }
  }

}

angular.module('wbComponents').directive('adminHeader', function() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: AdminHeader,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      userId: '='
    }
  }
})
